import React, { useState } from 'react';
import { Stack } from '@chakra-ui/react';
import ReusableDrawer from "../../../../components/Drawers/ReusableDrawer.js";
import headerImage from '../../../../assets/img/background.png';
import GradientButton from 'components/Buttons/GradientButton.js';
import ReusableInput from 'components/Inputs/ReusableInput.js';

const AddCommissionForm = ({ isOpen, onClose, onAddCommission, commissionType }) => {
  const [formData, setFormData] = useState({
    commissionPercentage: '',
    triggerDate: '',
    commissionType: commissionType,  // Add commissionType to formData
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const formDataToSubmit = {
      commission_percentage: parseFloat(formData.commissionPercentage),
      trigger_date: formData.triggerDate,
      commission_type: formData.commissionType,  // Include commissionType when submitting
    };

    // Call the action to add the commission
    onAddCommission(formDataToSubmit);
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Add {commissionType} Commission</h2>}  // Dynamic Header
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label={`${commissionType} Commission Percentage (%)`}  // Dynamic Label
            name="commissionPercentage"
            type="number"
            value={formData.commissionPercentage}
            onChange={handleInputChange}
            placeholder={`Enter ${commissionType} commission percentage`}  // Dynamic Placeholder
          />
          <ReusableInput
            label="Trigger Date"
            name="triggerDate"
            type="datetime-local"
            value={formData.triggerDate}
            onChange={handleInputChange}
            placeholder="Select trigger date and time"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize={"15px"} width={"100px"} height={"40px"}>Cancel</GradientButton>
          <GradientButton onClick={handleSubmit} fontSize={"15px"} width={"100px"} height={"40px"}>Save</GradientButton>
        </Stack>
      }
    />
  );
};

export default AddCommissionForm;
